import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
const SvgCaretDown = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 16 16" role="img" ref={ref} {...props}><path fill="currentColor" fillRule="evenodd" d="M.393 5.188C-.3 4.5-.049 3.939.906 3.939h14.181c.973 0 1.208.553.512 1.249l-6.353 6.354a1.763 1.763 0 0 1-2.5 0z" /></svg>;
const ForwardRef = forwardRef(SvgCaretDown);
export default ForwardRef;